import React, { useState, useEffect } from "react";
import VolumeErrorChart from "./components/VolumeErrorChart";
import "./style.css";
import { useSelector } from "react-redux";

const ExpandableRowsComponent = (props) => {
    const [chartData, setChartData] = useState([]);
    const language = useSelector((state) => state.languagesState.languages);

    useEffect(() => {
        if (props?.renderPixelIdProps) {
            for (let subKey in props.renderPixelIdProps) {
                if (subKey && subKey == "event_types") {
                    let subData = props.renderPixelIdProps[subKey];
                    setChartData(
                        subData[props?.title ?? ""]?.dates.map((item) => {
                            return {
                                name: item.date,
                                Total: item.all_events,
                                ...(subData[props?.title || ""]?.sum_data
                                    ?.all_errors
                                    ? { errors: item.all_errors }
                                    : {}),
                            };
                        }),
                    );
                }
            }
        }
    }, [props.renderPixelIdProps, props?.title]);

    return (
        <div className="px-3">
            <div className="row my-3">
                <div className="col-12 col-md-12">
                    <h5>{language?.reports?.active ?? "Active"}</h5>
                    <VolumeErrorChart
                        chartData={chartData}
                        destinationList={[]}
                        loader={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default ExpandableRowsComponent;
